const MediaTypes = Object.freeze({
  CHAT: "chat",
  EMAIL: "email",
  INBOUND_PHONE: "inbound_phone",
  OUTBOUND_PHONE: "outbound_phone",
  VOICEMAIL: "vmail",
});

export default MediaTypes;
